module.exports = __webpack_public_path__ + "static/media/leads.1f21679a.svg";